import { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Container,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../../../services/indexMediaBaseUrl";
import CategoriesTap from "./CategoriesTapCompo/CategoriesTap";
import ProductsTap from "./ProductsPage/ProductsTap";

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 0 }}>{children}</Box>;
}

const ProductsAndCategoryMainPage = () => {
  const { t, i18n } = useTranslation(); // initReactI18next compatible

  // اقرأ حالة الترجمة من localStorage عند التحميل
  useEffect(() => {
    const raw = localStorage.getItem("lang");
    let lang = raw || i18n.language || "ar";
    if (lang === "rn") lang = "en";
    lang = lang.startsWith("ar") ? "ar" : "en";
    if (i18n.language !== lang && typeof i18n.changeLanguage === "function") {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [i18n]);

  const [tab, setTab] = useState(() => {
    const v = localStorage.getItem("adminTab");
    return v !== null ? Number(v) : 0;
  });

  // products state
  const [products, setProducts] = useState([]);
  const [prodLoading, setProdLoading] = useState(false);
  const [prodError, setProdError] = useState(null);
  const handleTab = (e, v) => {
    setTab(v);
    try {
      localStorage.setItem("adminTab", String(v));
    } catch {}
  };

  return (
    <Container maxWidth="lg" sx={{ pt: 0, pb: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tab}
          onChange={handleTab}
          aria-label={t(
            "admin.tabs_label",
            { defaultValue: "فئات المنتجات والمنتجات" }
          )}
        >
          <Tab
            label={t("admin.categories_tab", { defaultValue: "فئات المنتجات" })}
          />
          <Tab
            label={t("admin.products_tab", { defaultValue: "المنتجات" })}
          />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0}>
        <CategoriesTap />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <ProductsTap />
      </TabPanel>
    </Container>
  );
};

export default ProductsAndCategoryMainPage;
